export default __webpack_public_path__ + "static/media/skulls-1.f098ffd0.png";